import { Router } from "@angular/router";
import { of } from "rxjs";
import { AsyncSubject, forkJoin, timer } from "rxjs";
import { catchError } from "rxjs/operators";
import Swal from "sweetalert2";
import { ShopService } from "../api/shop.service";
import { CartService } from "../services/cart.service";

export const ERROR_GIACENZA_CODE = [10025, 10023];

export function handleGiacenzaError(router : Router, cart : CartService, shop : ShopService) {
    let updatedArticoliSubject = new AsyncSubject();

    Swal.fire({
        text: 'Uno o più articoli del documento non sono più disponibili o non sono disponibili nella quantità richiesta',
        icon: 'error',
        buttonsStyling: false,
        allowEscapeKey : false,
        allowOutsideClick: false,
        confirmButtonText: "Torna al carrello",
        customClass: {
            confirmButton: 'btn btn-primary'
        },
    }).then(_ => {
        router.navigateByUrl('/shop/cart');
        updatedArticoliSubject.subscribe(upToDateArticoli => {
            let report = cart.updateGiacenza(upToDateArticoli);
            
            let createArticoloDescription = (product, options) => {
                let output = `${product.descart}`;
                if (options) {
                    output += "<br>";
                    let option_output = "";
                    for (let key of Object.keys(options)) {
                        option_output += `<li>${options[key].list.descrizione}: ${options[key].option.codice}</li>`;
                    }
                    output += `<ul class="cart-table__options">${option_output}</ul>`;
                }

                return output;
            }
            
            let tableRemoved = "";
            for (let line of report.removed) {
                tableRemoved += `<tr><td style="border: 1px solid; text-align:left; padding: 5px 10px">${createArticoloDescription(line.product, line.options)}</td></tr>`;
            }

            let tableChanged = "";
            for (let line of report.changed) {
                tableChanged +=  `<tr><td style="border: 1px solid; text-align:left; padding: 5px 10px">${createArticoloDescription(line.product, line.options)}</td><td style="border: 1px solid; text-wrap: no-wrap; padding: 5px 10px"><span style="color:red">${line.oldQuantity}</span> &rarr; <span style="color:green">${line.newQuantity}</span></td></tr>`;
            }

            let output = "";
            if (tableRemoved) {
                tableRemoved = `<table style="width: 100%"><tbody>${tableRemoved}</tbody></table>`;
                output += "I seguenti articoli sono stati eliminati dal carrello<br><br>" + tableRemoved + "<br>";
            }

            if (tableChanged) {
                tableChanged = `<table style="width: 100%"><tbody>${tableChanged}</tbody></table>`;
                output += "La quantità dei seguenti articoli nel carrello è stata aggiornata alla quantità disponibile<br><br>" + tableChanged + "<br>";
            }

            Swal.fire({
                html: output,
                buttonsStyling: false,
                allowEscapeKey : false,
                allowOutsideClick: false,
                confirmButtonText: "OK",
                customClass: {
                    confirmButton: 'btn btn-primary'
                }
            });
        });
    });

    timer(0).subscribe(_ => {
        let codartSet = new Set<string>();

        for (let item of cart.items) {
            codartSet.add(item.product.codart);
        }

        let requests = {};
        for (let codart of Array.from(codartSet)) {
            requests[codart] = shop.getArticolo(codart).pipe(catchError(err => of(null)));
        }

        forkJoin(requests).subscribe(r => {
            updatedArticoliSubject.next(r);
            updatedArticoliSubject.complete();
        });

    });

}